"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AnnotationStoryText;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _commentStyle = require("./commentStyle");

var _base = require("../../base");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AnnotationStoryText(_ref) {
  var highlightedText = _ref.highlightedText,
      inStoryText = _ref.inStoryText;

  if (inStoryText) {
    return /*#__PURE__*/_react.default.createElement(_commentStyle.HighlightedTextContainer, null, /*#__PURE__*/_react.default.createElement(_commentStyle.HighlightedText, null, highlightedText));
  }

  return /*#__PURE__*/_react.default.createElement(_commentStyle.HighlightedTextContainer, null, /*#__PURE__*/_react.default.createElement(_commentStyle.StyledSubtext, null, "Original Selected Text:"), /*#__PURE__*/_react.default.createElement(_base.P, null, highlightedText));
}

;
AnnotationStoryText.defaultProps = {
  highlightedText: "",
  inStoryText: false
};
AnnotationStoryText.propTypes = {
  highlightedText: _propTypes.default.string,
  inStoryText: _propTypes.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/comments/Comment/AnnotationStoryText.js
// module id = 817
// module chunks = 0 15 16 17 18